module.exports = __webpack_public_path__ + "static/media/TechnologyIcon.bcfe56bc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Layout/Svg/TechnologyIcon.svg
// module id = 1359
// module chunks = 0